<template>
    <v-container>
        <v-layout wrap :class="`card_${cardColor} card`" style="height: 50px" @click="click()">
            <v-flex xs3 class="d-flex flex-column align-center justify-center">
                <v-icon color="#FFF" size="1.5em">{{ cardIcon }}</v-icon>
                <span style="padding: 0px">{{ cardValue }}{{ unit }}</span>
            </v-flex>
            <v-flex xs9 style="color: #fff" class="d-flex align-center pl-4">
                {{ cardTitle }}
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script lang="ts">
import { Component, Emit, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class SingleDataCard extends Vue {
    @Prop({ type: String, required: true }) readonly title: string;
    @Prop({ type: String, required: true }) readonly icon: string;
    @Prop({ type: String || Number, required: true }) readonly value: string | number;
    @Prop({ default: "" }) readonly unit: string;
    @Prop({ type: String }) readonly text: string;
    @Prop({ type: String }) readonly color: string;
    @Prop({ type: String }) readonly iconSize: string;
    @Prop({ type: String }) readonly iconColor: string;

    get cardTitle() {
        return this.title;
    }

    get cardIcon() {
        return this.icon;
    }

    get cardValue() {
        return this.value;
    }

    get cardUnit() {
        return this.unit;
    }

    get cardText() {
        return this.text;
    }

    get cardColor() {
        return this.color || "primary";
    }

    get cardIconSize() {
        return this.iconSize || "20";
    }

    get cardIconColor() {
        return this.iconColor || "white";
    }

    @Emit()
    click() {
        return;
    }
}

export default toNative(SingleDataCard);
</script>
<style scoped lang="scss">
.card {
    border-radius: 5px;
    font-size: 0.9em;
    .dark {
        color: #fff;
        font-size: 1em;
        border-radius: 5px 0 0 5px;
    }
}

.card_yellow {
    background-color: #f9b12a;
    .dark {
        background: rgba(0, 0, 0, 0.2);
    }
}

.card_green {
    background-color: #63c1bc;
    .dark {
        background: rgba(0, 0, 0, 0.2);
    }
}

.card_blue {
    background-color: #262626;
    .dark {
        background: rgba(255, 255, 255, 0.2);
    }
}
</style>
